import React from 'react';
import AdminSuggestion from '../../components/Common/AdminSuggestion/AdminSuggestion';
import Footer from '../../components/Common/Footer/Footer';
import Header from '../../components/Common/Header/Header';
import Special from '../../components/Common/Special/Special';
import SubHeader from '../../components/Common/SubHeader/SubHeader';
import ProfileBanner from '../../components/Profile/ProfileBanner/ProfileBanner';
import ProfileBoard from '../../components/Profile/ProfileBoard/ProfileBoard';

const Profile = () => {
    return (
        <div>
            <SubHeader/>
            <Header/>
            <ProfileBanner/>
            <ProfileBoard/>
            <AdminSuggestion/>
            <Special/>
            <Footer/>
        </div>
    );
};

export default Profile;